






















































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import DlgInfo from '@/common/entity/DlgInfo'
import Breadcrumb from '@/common/components/Breadcrumb/index.vue'
import Hamburger from '@/common/components/Hamburger/index.vue'
import FormChangePassword from '@/views/login/form/form-change-password.vue'

@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger,
    FormChangePassword
  }
})
export default class extends Vue {
  private dlgInfo: DlgInfo = new DlgInfo()
  private isShow = false

  get userName() {
    return UserModule.name
  }
  get sidebar() {
    return AppModule.sidebar
  }

  get device() {
    return AppModule.device.toString()
  }

  get avatar() {
    if (UserModule.avatar) {
      return UserModule.avatar
    } else {
      return require('@/assets/logo.jpg')
    }
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }
  private visibleChange(val:boolean){
    console.log(val)
    this.isShow = val
  }

  private async logout() {
    await UserModule.LogOut()
    this.$router.push(`/login`)
  }

  private changePassword() {
    // 修改密码
    this.dlgInfo.formName = 'changePassword'
    this.dlgInfo.width = '400px'
    this.dlgInfo.title = '修改密码'
    this.dlgInfo.formData = {
      id: UserModule.id,
      account: UserModule.account,
      token: UserModule.token
    }
    this.dlgInfo.show = true
    this.dlgInfo.uiStatus = 0
  }

  cancelDlg() {
    this.dlgInfo.show = false
    setTimeout(() => {
      this.dlgInfo.formData = {}
      this.dlgInfo.formName = ''
    }, 200)
  }

  submitDlg(ret: any) {
    this.cancelDlg()
  }
}
